(function (m, $) {

    m.deviceSizeSmallest = 460;
    m.deviceSizeSmall = 600;
    m.deviceSizeMedium = 960;
    m.deviceSizeLarge = 1280;

    m.bindWindowResize = function () {
        $(window).on("resize", function () {
            $(".visible-menu").removeClass("visible-menu");
            $(".ux-mobile-menu-button").find(".fa").removeClass("fa-times").addClass("fa-bars");
        });
    };

    m.bindPublicPages = function () {
        var notificationModal = $(".ux-notification-modal");

        if (notificationModal.length) {
            var notificationModalButtons = [];

            var notificationModalButtonsJson = notificationModal.data("dialogButtons");

            for (var i = 0; i < notificationModalButtonsJson.length; i++) {
                var buttonText = notificationModalButtonsJson[i].text;
                var buttonUrl = notificationModalButtonsJson[i].url;

                var button = {
                    text: buttonText,
                    click: (function (thisUrl) {
                        return function () {
                            if (thisUrl === "close")
                                $(this).dialog("close");
                            else
                                window.location.href = thisUrl;
                        }
                    })(buttonUrl)
                }

                notificationModalButtons.push(button);
            }

            notificationModal.dialog({
                title: notificationModal.data("dialogTitle"),
                modal: true,
                autoOpen: true,
                resizable: false,
                draggable: true,
                buttons: notificationModalButtons
            });
        }
        $(".ui-dialog :button").blur();

        $("input[type=radio]:checked").closest(".ux-radio-button").addClass("selected-radio-button");
        $("input[type=radio]").click(function() {
            $("input[type=radio]").closest(".ux-radio-button").removeClass("selected-radio-button");
            $("input[type=radio]:checked").closest(".ux-radio-button").addClass("selected-radio-button");
        });
    };

    var temporaryMessageTimeout;
    m.showTemporaryMessage = function (message, isError) {
        clearTimeout(temporaryMessageTimeout);
        var messageContainer = $(".ux-temporary-notification");
        messageContainer.toggleClass("is-error", isError);
        messageContainer.find("p").html(message);
        messageContainer.slideDown();

        temporaryMessageTimeout = setTimeout(function() {
            messageContainer.slideUp();
        }, isError ? 8000 : 2000);
    };

    m.getData = function(elementId) {
        var element = document.getElementById(elementId);
        var string = element.textContent || element.innerText;
        var data = JSON.parse(string);
        element.parentNode.removeChild(element);
        return data;
    };

    m.createCookie = function(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + value + expires + "; path=/";
    }

    m.readCookie = function(name) {
        var nameEq = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEq) == 0) return c.substring(nameEq.length, c.length);
        }
        return null;
    };

    m.createStaticUrl = function(relativeUrl) {
        if (relativeUrl.startsWith("http"))
            return relativeUrl;

        let cleanUrl = relativeUrl.replace(/^[\/ ]+/g, '');
        return m.StaticSite + '/' + cleanUrl;
    };

    m.createGoogleMapsMarkerIcon = function(url) {
        var iconImage = {
            url: m.createStaticUrl(url),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(11, 40),
            scaledSize: new google.maps.Size(22, 40)
        };

        return iconImage;
    };

    $.validator.addMethod("mustbetrue", function (value, element, params) {
        return $(element).is(":checked");
    });
    $.validator.unobtrusive.adapters.addBool("mustbetrue");

}(window.ooooby = window.ooooby || {}, jQuery));

$(document).ready(function () {
    ooooby.bindWindowResize();
    ooooby.bindPublicPages();
});